import {Component, EventEmitter, Input, Output} from '@angular/core';
import {WorkflowVariableDescriptor} from '../../conditions/types';
import {Ast} from '@ngmedax/expression-compiler';

@Component({
  selector: 'app-workflow-conditions-editor',
  templateUrl: './workflow-conditions-editor.component.html',
  styleUrls: ['./workflow-conditions-editor.component.css']
})
export class WorkflowConditionsEditorComponent {
  @Input() variables: WorkflowVariableDescriptor[] = [];
  @Input() value: Ast.Group;
  @Output() valueChange = new EventEmitter<Ast.Group>();

  public onGroupChange(g: Ast.Group) {
    this.value = g;
    this.valueChange.emit(g);
  }
}


